import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { TopBarSlim } from '../TopBarSlim';
import { UseCaseVariationEnums } from '../TopBarSlimEnums';
import { Link, Typography } from '@sm/wds-react';

const DEFAULT_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCasePerformanceEvaluationTopBarSlim.message',
    defaultMessage:
      'Gauge performance with 360-degree evaluations. Start with a ready-to-go template.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCasePerformanceEvaluationTopBarSlim.ctaText',
    defaultMessage: 'See all plans',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

const COLLECT_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCasePerformanceEvaluationTopBarSlim.messageCollect',
    defaultMessage:
      "Track performance with recurring surveys. Pick the cadence and we'll send new links.",
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCasePerformanceEvaluationTopBarSlim.ctaTextCollect',
    defaultMessage: 'See all plans',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

const ANALYZE_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCasePerformanceEvaluationTopBarSlim.messageAnalyze',
    defaultMessage:
      'Export and print performance evaluations for employees. { ctaTextAnalyze } and make sharing easier.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCasePerformanceEvaluationTopBarSlim.ctaTextAnalyze',
    defaultMessage: 'Upgrade today',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

export type UseCasePerformanceEvaluationTopBarSlimProps = {
  variation?: UseCaseVariationEnums | null;
};

const VariationToCopy = {
  [UseCaseVariationEnums.create]: DEFAULT_COPY,
  [UseCaseVariationEnums.collect]: COLLECT_COPY,
  [UseCaseVariationEnums.analyze]: ANALYZE_COPY,
};

export const UseCasePerformanceEvaluationTopBarSlim: React.FC<UseCasePerformanceEvaluationTopBarSlimProps> = ({
  variation,
}) => {
  const copy =
    variation && variation in VariationToCopy
      ? VariationToCopy[variation]
      : DEFAULT_COPY;
  const ut_source = variation
    ? `slim_${variation}_upsell_performance_evaluation`
    : 'slim_create_upsell_performance_evaluation';
  const url = createURL('/pricing/upgrade/', {
    ut_source: 'topbar',
    ut_source2: ut_source,
  });

  // For the analyze variant, the CTA is displayed as part of the message.
  const ctaTextAnalyze = (
    <Link className="wds-display--inline-block" href={url} target="_blank">
      <Typography className={`sm-top-bar-slim--info__cta-text`}>
        {t(copy.CTA_TEXT)}
      </Typography>
    </Link>
  );

  return (
    <TopBarSlim
      message={t(copy.MESSAGE, { ctaTextAnalyze })}
      ctaText={
        variation != UseCaseVariationEnums.analyze
          ? t(copy.CTA_TEXT)
          : undefined
      }
      ctaLink={url}
      ctaNewTab
    />
  );
};

export default UseCasePerformanceEvaluationTopBarSlim;
